import { TreatmentFlags } from 'constants/treatments'
import { StimulantStateBucketValue } from 'constants/treatmentValues'
import useGetTreatment from 'hooks/treatments/useGetTreatment'

export type StimulantStateBucket =
  | 'onlineAllowed'
  | 'inPersonOffered'
  | 'inPersonNotOffered'
  | 'noStimulants'

type UseStimulantBucketResult = {
  bucket: StimulantStateBucket | null
  isReady: boolean
}

/**
 * Resolves stimulant state bucket from Harness flag STIMULANT_STATE_BUCKET_MESSAGES.
 * Passes attribute `{ state }` (2-letter abbreviation). While Split is not ready
 * or returns control, bucket is null (show nothing). dummy_else_psych_not_available
 * is a resolved else: psych is not available, so the bucket stays null.
 */
const useStimulantBucket = (state: string): UseStimulantBucketResult => {
  const treatment = useGetTreatment(
    TreatmentFlags.STIMULANT_STATE_BUCKET_MESSAGES,
    !!state,
    { state }
  )

  if (!state || treatment === StimulantStateBucketValue.CONTROL) {
    return { bucket: null, isReady: false }
  }

  switch (treatment) {
    case StimulantStateBucketValue.ONLINE_ALLOWED:
      return { bucket: 'onlineAllowed', isReady: true }
    case StimulantStateBucketValue.IN_PERSON_OFFERED:
      return { bucket: 'inPersonOffered', isReady: true }
    case StimulantStateBucketValue.IN_PERSON_NOT_OFFERED:
      return { bucket: 'inPersonNotOffered', isReady: true }
    case StimulantStateBucketValue.NOT_STIMULANT:
      return { bucket: 'noStimulants', isReady: true }
    case StimulantStateBucketValue.PSYCH_NOT_AVAILABLE:
      return { bucket: null, isReady: true }
    default:
      return { bucket: null, isReady: false }
  }
}

export default useStimulantBucket
